import { useEffect, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTimer } from 'react-timer-hook';

// import { t } from 'i18next';

import { useCloseUnusedRoom } from 'modules/Room/Hooks/useCloseUnusedRoom';

// import AnimatedTransition from 'shared/components/ui/AnimatedTransition/AnimatedTransition';
// import {
//   CountdownTimer,
//   CountdownTimerType,
// } from 'shared/components/ui/CountdownTimer/CountdownTimer';
import { TIME_BEFORE_SHOW_TIMER_IN_MODALS } from 'shared/constants/timers';
import { Timer } from 'shared/constants/types';
import { useAccount } from 'shared/hooks/use-web3';
import { useRoomStore } from 'shared/store/roomStore';
import { epochToLocalUTC } from 'shared/utils/time';

import { useWaitYourMoveGameStatusText } from './use-wait-your-move-game-status-text';

export const WaitYourMoveStatus = () => {
  const { activeRoomId } = useParams();
  const { address, chainId } = useAccount();
  const [showTimer, setShowTimer] = useState(false);
  const [showCloseButton, setShowCloseButton] = useState(false);
  const timeOutRef = useRef<null | Timer>(null);
  const { closerRoom, roundCounter, lastRoundOutcome, setRoomExpire } = useRoomStore();

  // const onExpire = useCallback(() => {
  //   setShowCloseButton(true);
  //   setRoomExpire(true);
  // }, [setRoomExpire]);
  useTimer({
    expiryTimestamp: epochToLocalUTC(closerRoom?.deadline),
    onExpire: () => {
      setShowCloseButton(true);
      setRoomExpire(true);
    },
  });

  const rawDeadline = closerRoom?.deadline;

  const expiryDate = useMemo<Date | null>(() => {
    if (!rawDeadline || rawDeadline <= 0) return null;
    const maybeDate = epochToLocalUTC(rawDeadline) as unknown as Date;
    const dateObj = maybeDate instanceof Date ? maybeDate : new Date(maybeDate as any);
    if (Number.isNaN(dateObj.getTime())) return null;
    return dateObj;
  }, [rawDeadline]);

  const { restart } = useTimer({
    expiryTimestamp: new Date(Date.now() + 1000),
    autoStart: false,
  });

  useEffect(() => {
    if (expiryDate) restart(expiryDate, true);
  }, [expiryDate, restart]);

  const key = `${activeRoomId}_${address}_${chainId}_${roundCounter}`;

  useEffect(() => {
    const storageKey = `waitYourMoveShowTimer_${key}`;
    const savedTime = sessionStorage.getItem(storageKey);

    const currentTime = new Date();

    if (!savedTime) {
      const targetTime = new Date(currentTime.getTime() + TIME_BEFORE_SHOW_TIMER_IN_MODALS);
      sessionStorage.setItem(storageKey, targetTime.toISOString());

      timeOutRef.current = setTimeout(() => {
        setShowTimer(true);
      }, TIME_BEFORE_SHOW_TIMER_IN_MODALS);
    } else {
      const targetTime = new Date(savedTime);
      const diff = targetTime.getTime() - currentTime.getTime();
      if (diff <= 0) setShowTimer(true);
      else timeOutRef.current = setTimeout(() => setShowTimer(true), diff);
    }

    return () => clearTimeout(timeOutRef.current as Timer);
  }, [key]);

  const { isSuccess, technicalDefeatError } = useCloseUnusedRoom();
  const { getTextComponent } = useWaitYourMoveGameStatusText(
    isSuccess,
    showTimer,
    showCloseButton,
    technicalDefeatError,
    lastRoundOutcome,
  );

  return (
    <>
      {getTextComponent()}
      {/* todo: remove full after Michael approve */}
      {/* <AnimatedTransition show={showTimer && !showCloseButton}>
        <CountdownTimer
          expiryTimestamp={epochToLocalUTC(closerRoom?.deadline)}
          onComplete={onExpire}
          type={CountdownTimerType.WARNING}
          description={t('modals.waitYourMove.timerSelectDescription')}
        />
      </AnimatedTransition> */}
    </>
  );
};
